import { render, staticRenderFns } from "./Catchs.vue?vue&type=template&id=4174d88b&scoped=true"
import script from "./Catchs.vue?vue&type=script&lang=js"
export * from "./Catchs.vue?vue&type=script&lang=js"
import style0 from "./Catchs.vue?vue&type=style&index=0&id=4174d88b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4174d88b",
  null
  
)

export default component.exports